import { NotificationSettingsConfig } from "@ui/context/component-config-context";

const notificationSettings: NotificationSettingsConfig = {
  toggleSettings: [
    {
      label: "Replies to your comments",
      key: "onCommentReply",
    },
    {
      label: "Replies to your posts",
      key: "onPostReply",
    },
    {
      label: "My pending comment has been reviewed",
      key: "onModeration",
    },
    {
      label: "Recs on your posts and comments",
      key: "onRec",
    },
  ],
};

export default notificationSettings;
